<template>
    <div class="contact-flex">
        <a href="#/" @mousedown.left="() =>{isOpen ? hide() : show()}">
            <div class="contact-help">
                <h3>Χρειάζεστε Βοήθεια;</h3>
            </div>
        </a>
        <transition name="show" appear>
            <div class="contact-details">
                <h3>Είμαστε εδώ για σας.</h3>
                <a href="tel:+302109889380"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z"/></svg>210 988 9380</a>
                <a href="mailto:info@katsenis.gr"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M464 64C490.5 64 512 85.49 512 112C512 127.1 504.9 141.3 492.8 150.4L275.2 313.6C263.8 322.1 248.2 322.1 236.8 313.6L19.2 150.4C7.113 141.3 0 127.1 0 112C0 85.49 21.49 64 48 64H464zM217.6 339.2C240.4 356.3 271.6 356.3 294.4 339.2L512 176V384C512 419.3 483.3 448 448 448H64C28.65 448 0 419.3 0 384V176L217.6 339.2z"/></svg>Στείλτε μας Email</a>
                <a href="/epikoinonia"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M511.1 63.1v287.1c0 35.25-28.75 63.1-64 63.1h-144l-124.9 93.68c-7.875 5.75-19.12 .0497-19.12-9.7v-83.98h-96c-35.25 0-64-28.75-64-63.1V63.1c0-35.25 28.75-63.1 64-63.1h384C483.2 0 511.1 28.75 511.1 63.1z"/></svg>Επικοινωνία</a>
            </div>
        </transition>
    </div>
</template>

<script>

export default ({
    name: 'vue-contact',
     data () {
        return{
            isOpen: false,
            windowWidth: window.innerWidth
        }
    }, 
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
    },

    beforeDestroy() { 
        window.removeEventListener('resize', this.onResize); 
    },
    methods: {
        show(){
            document.querySelector('.contact-details').style.marginRight = '0px';
            this.isOpen=true;
        }, 
        hide(){
            console.log(this.windowWidth);
            if(this.windowWidth<=400){
                document.querySelector('.contact-details').style.marginRight = '-230px';
                this.isOpen=false;
            }
            else{
                document.querySelector('.contact-details').style.marginRight = '-300px';
                this.isOpen=false;
            }
        }, 
    }
})
</script>

<style>
    .contact-flex{
        display: flex;
        z-index: 99;
        position: fixed;
        top:50% !important;
        right: 0;
        transform: translate(0%, -50%);  
        align-items: flex-end;
    }
    .contact-flex a{
        text-decoration: none;
    }
    .contact-help{
        width: 75px;
        height: 300px;
        background: #f1bc1e;
        border-radius: 50px 50px 0px 0px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        text-decoration: none;
    }
    .contact-help img{
        padding: 5px;
        width: 75px;
        height: 75px;
    }
    .contact-help h3{
        color:#000;
        font-size: 25px;
        writing-mode: tb-rl;
        transform: rotate(-180deg);
        margin-bottom: 40px;
        font-family: Manrope;
        font-weight: 500;
        letter-spacing: 2px;
    }
    .contact-details{
        background: rgb(27, 27, 27);
        width: 300px;
        height: 260px;
        border-top: 3px solid #d4a51c;
        border-bottom: 3px solid #d4a51c;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-right: -300px;
        transition-duration: 1s;
    }
    .contact-details h3, .contact-details a{
        color:#fff !important;
        line-height: 40px;
        font-size: 20px;
        font-family: Manrope;
        text-decoration: none;
        text-align: left;
        margin-left:10%;
    }
    .contact-details h3{
        font-size: 23px;
        font-weight: 600;
        line-height: 75px;
        margin-top:6%;
        margin-left:10%;
    }
    .contact-details a svg{
        margin-right: 20px;
        filter: invert(60%) sepia(96%) saturate(369%) hue-rotate(3deg) brightness(110%) contrast(101%);
    }
    .contact-details a:hover{
        color: #ffc720 !important;
    }
    
    @media only screen and (max-width: 400px) {
        .contact-details h3{
            font-size: 20px;
        }
        .contact-details a{
            font-size: 15px;
        }
        .contact-details{
            width:230px;
            margin-right: -230px !important;
        }
        .contact-help{
            width: 60px;
        }
        .contact-help img{
            width: 60px;
            height: 60px;
        }
    }   

</style>